<template>
  <div class="wrapper">
    <!-- 見出し -->
    <h3 class="heading">
      他の支部の自由項目を利用する（共有設定）
    </h3>

    <!-- フォーム -->
    <el-form :inline="true">
      <el-form-item label="得意先コード:">
        <el-input
          v-model="localSourceClientGroupId"
          size="small"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="submit"
        >
          送 信
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="isSetConfigSourceClientGroupId"
          type="text"
          @click="confirmRelease"
        >
          共有設定を解除
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 注意事項 -->
    <p class="caption">
      <span class="required">※</span> 共有設定中は「商品カテゴリの設定」「掲載する商品の設定」は行えません
    </p>
  </div>
</template>

<script>
export default {
  name: "AdminClientsProductsManagementConfigSource",
  components: {},
  props: {
    sourceClientGroupId: {
      type: String,
    },
    isSetConfigSourceClientGroupId: {
      type: Boolean,
    },
  },
  computed: {
    localSourceClientGroupId: {
      get () {
        return this.sourceClientGroupId;
      },
      set (value) {
        this.$emit("update:sourceClientGroupId", value);
      },
    },
  },
  methods: {
    /**
     * submit
     */
    submit () {
      this.$emit("update:productDisplaySettingSource", this.sourceClientGroupId);
    },

    /**
     * submit
     */
    confirmRelease () {
      if (!window.confirm("共有設定を解除してもよろしいですか？")) {
        return;
      }

      this.$emit("update:productDisplaySettingSource", "");
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.wrapper {
  margin: 12px 15px 15px;
  padding: 12px 15px 15px;

  .caption {
    margin: 0;
    font-size: 12.5px;

    .required {
      color: #ff0000;
    }
  }
}

</style>
